import { GLOBAL_OBJ as o } from "./chunk850.js";
const t = o;
export {
  t as WINDOW
};
